
import { enableMuteBypass, disableMuteBypass, wakeAudio } from './audioEngine';

let wired = false;

export function initAudioSession(): void {
  if (wired || typeof window === 'undefined') return;
  wired = true;
  window.addEventListener('pointerdown', enableMuteBypass);
  window.addEventListener('touchend', enableMuteBypass);
  window.addEventListener('keydown', enableMuteBypass);
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) disableMuteBypass();
    else wakeAudio();
  });
  // WHY: visibilitychange skips window switches and bfcache returns, which also come back with a closed context — wake on
  // focus + pageshow
  window.addEventListener('focus', wakeAudio);
  window.addEventListener('pageshow', wakeAudio);
  enableMuteBypass();
}
